export const English = {
  language: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
      ENGLISH: 'English',
      RUSSIAN: 'Russian',
    },
    MENU: {
      HOME: 'Home',
      PROFILE: 'My Profile',
      INTERVIEWS: 'Interviews',
      ACCOUNT: 'Account',
      SETTINGS: 'Settings',
      IDENTITY: 'Identity',
      NOTIFICATION: 'Notification',
      CONFIGURATION: 'Configuration',
      INFO: 'Info',
      DEPARTMENT: 'Department',
      EMPLOYEES: 'Employees',
      EVENTS: 'Events',
      EVENT_TYPE: "Event Type's",
      VIRTUAL_PC: 'Virtual PC (RDP)',
      WAGES: 'Wages',
      KARMA: 'Karma',
      RECRUITING: 'Recruiting',
      REFERRALS: 'Referrals',
      INVENTORY: 'Inventory',
      RAPORTS: 'Raports',
      CALENDARS: 'Calendars',
      VACATIONS: 'Vacations',
      OFFDAY: 'Off Day',
      MEDICAL: 'Medical',
      PART_TIME: 'Part Time',
      PURCHASES: 'Purchases',
      REQUESTS: 'Requests',
      ORDERS: 'Orders',
      FILES: 'Files',
      CONTRACT_FILE: 'Contract File',
      TICKETS: 'Tickets',
      COMPLETED: 'Completed',
      SPRINT: 'Sprint',
      SPRINTS: 'Sprints',
      SPRINT_BOARD: 'Sprint Board',
      ACTIVE_SPRINT: 'Active Sprint',
      BACKLOG: 'Backlog',
      PROJECTS: 'Projects',
      COMPANIES: 'Companies',
      TEAM: 'Team',
      USER_ROLES: 'User Roles',
      USER_PCS: 'User PCs (RDP)',
      ENABLED: 'Enabled',
      DISABLED: 'Disabled',
      POSITIONS: 'Positions',
      SKILLS: 'Skills',
      WORK_STATUSES: 'Work Statuses',
      TASK_TYPE: 'Task Type',
      KPI: 'Kpi',
      CALENDAR: 'Calendar',
      ANALYTICS: 'Analytics',
    },
    MODAL: {
      SAVE: 'Save',
      CANCEL: 'Cancel',
      YES: "Yes, I'm sure",
      NO: 'No, cancel',
      EVENT: 'Event',
      SAVING: 'Saving...',
      ADD: 'Add',
      CREATE: 'Create',
      EDIT: 'Edit',
      UPDATE: 'Update',
      UPDATE_ORDER_STATUS: 'Update Order Status',
      UPDATE_ORDER: 'Update Order',
      VIEW_ORDER: 'View Order',
      DELETE: 'Delete',
      DELETE_MESSAGE: 'Are you sure to permanently delete',
      ADD_NEW_USER: 'Add new user',
      ADD_NEW_ROLE: 'Add new role',
      EDIT_USER: 'Edit user',
      EDIT_ROLE: 'Edit role',
      EDIT_KARMA: 'Edit karma',
      VIEW_USER: 'View user details',
      DELETE_USER: 'Delete User',
      DELETE_ROLE: 'Delete Role',
      UPDATE_USER_PASSWORD: 'Update user password',
      ADD_EVENT: 'Add event',
      EDIT_EVENT: 'Edit event',
      WORK_STATUS: 'Work status',
      INVENTORY: 'Inventory',
      CONFIRM: 'Confirm',
      CONFIRM_CANDIDATE: 'Approve this candidate?',
      FILE_NOT_FOUND: 'File not found',
      ADD_FILE: 'Add',
      UPDATE_FILE: 'Edit',
      ADD_ORDER: 'Add Order',
      ADD_MEMBERS: 'Add Members',
      ADD_ASSIGNEE: 'Add Assignee',
      DISMISS: 'Fire Employee',
      REHIRE: 'Rehire Employee',
      REFERRAL: 'Referral',
      NOTIFICATION: 'Heads Up',
      EDIT_SPRINT: 'Edit Sprint',
      EMPLOYEE_REPORT: 'Employee Report',
      ADD_KPI: 'Add Kpi',
      ARE_YOU_SURE: 'Are you sure?',
      APPROVE: 'Approve',
    },
    TABLE: {
      NAME: 'Name',
      EMAIL: 'Email',
      PHONE: 'Phone',
      NOTE: 'Note',
      EMPLOYEE: 'Employee',
      MESSAGE: 'Message',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      NOT_ASSIGNED: 'Not assigned',
      DEPARTMENT: 'Department',
      POSITION: 'Position',
      CREATION_TIME: 'Creation Time',
      REGISTRATION_DATE: 'Registration Date',
      RESPONSE_TIME: 'Response Time',
      TYPE: 'Type',
      STATUS: 'Status',
      ACTIONS: 'Actions',
      COMPANY: 'Company',
      SALARY: 'Salary ($)',
      NOTES: 'Notes',
      GENDER: 'Gender',
      KPI_TARGET: 'Kpi Target',
      COMPANY_NAME: 'Company Name',
      DOCUMENT: 'Document',
      DESCRIPTION: 'Description',
      RATE: 'Rate',
      AUTHOR: 'Author',
      IMAGE: 'Image',
      EXTENSION: 'Extension',
      PROJECT: 'Project',
      KEY: 'Key',
      PROJECT_TYPE: 'Project Type',
      PROJECT_LEAD: 'Project Lead',
      PROJECT_CATEGORY: 'Project Category',
      URL: 'URL',
      IS_DEFAULT: 'Is Default',
      VIEW_TYPES: 'View types',
      CODE: 'Code',
      TEAM_LEAD: 'Team Lead',
      TEAM_MEMBER: 'Team Member',
      TEAM_MEMBERS: 'Team Members',
      EMPLOYMENT_DATE: 'Employment Date',
      ICON: 'Icon',
      BASE_SALARY: 'Base Salary',
      COMMENT: 'Comment',
      TASK: 'Task',
      SKILL_NAME: 'Skill Name',
      AMOUNT: 'Amount',
      DATE: 'Date',
      ID: 'ID',
      WORK_STATUS: 'Work Status',
      COST: 'Item Cost',
      REQUIRES_SUM: 'Requires Sum',
      DISTINGUISH_NAME: 'Distinguished Name',
      EMPLOYMENT_TIME: 'Employment Time',
      PRICE: 'Price',
      CREATED_AT: 'Created At',
      PERIOD: 'Period',
      CREATED_BY: 'Created By',
      SPRINT_NAME: 'Sprint Name',
      PROJECT_ASSIGNED: 'Project Assigned',
      TASKS: 'Tasks',
      END_DATE: 'End Date',
      TIME: 'Time',
      IS_FIRED: 'Is Fired',
      USERNAME: 'Username',
      STORY_POINTS: 'Story Points',
      TEAM_MANAGEMENT: 'Team Management',
      BUG_FIXES: 'Bug Fixes Duration (h)',
      ASSIGNED_HOURS: 'Assigned Hrs',
      ESTIMATED_HOURS: 'Est. Hrs',
      WORKED_HOURS: 'Worked Hours',
      COMPLETION: 'Completion',
      PRODUCTIVITY: 'Productivity (%)',
      EXPORT: 'Export',
      LOGGED_HOURS: 'Logged Hrs',
      BUGS: 'Bugs',
      COMPLETION_PERCENTAGE: 'Completion Percentage',
      PRODUCTIVITY_PERCENTAGE: 'Productivity Percentage',
      TOTAL_LOGGED_HOURS: 'Total Logged Hours',
      TOTAL_ESTIMATED_HOURS: 'Total Estimated Hours',
      ESTIMATED_TIME: 'Estimated Time (h)',
      LOGGED_TIME: 'Logged Time (h)',
      START_DATE: 'Start Date',
      TOTAL_LOGGED_TIME: 'Total Logged Time (h)',
      TOTAL_ESTIMATED_TIME: 'Total Estimated Time (h)',
      ASSIGNEE: 'Assignee',
      ISSUE_TYPE: 'Issue type',
      PRIORITY: 'Priority',
      STORY_POINT: 'Story point',
      ESTIMATE_TIME: 'Estimate time (h)',
      TOTAL_OVERTIME: 'OT Hrs',
      TOTAL_PROBLEM_TIME: 'Total Logged Problem Time (h)',
      ESTIMATED_BUG_FIXES: 'Bug Fixes Estimated (h)',
      LOGGED_BUG_FIXES: 'Bug Fix Hrs',
      PROBLEM_LOGGED_TIME: 'Problem Hrs',
      IT_HELP_LOGGED_TIME: 'IT Help Logged (h)',
      IT_HELP_ESTIMATED_TIME: 'IT Help Estimated (h)',
      BUSY_HOURS: 'Busy Hrs',
      MORE: 'More',
      ROLE: 'Role',
      EMPLOYMENT_PERCENTAGE: 'Employment %',
      TOTAL_EFFECTIVE_TIME: 'Total Effective Time (avg)',
      TOTAL_EFFECTIVE_LOGGED_HOURS: 'Eff. Logged Hrs',
      TOTAL_EFFECTIVE_LOGGED_PERCENTAGE: 'Eff. Logged %',
      TICKET_TYPE: 'Ticket Type',
      TOTAL_EFFECTIVE_LOGGED_HOURS_WITH_IT_HELP_PERCENTAGE: 'Eff. Logged with IT Help %',
      TOTAL_EFFECTIVE_LOGGED_HOURS_WITH_IT_HELP: 'Eff. Logged with IT Help',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications',
      ALERTS: 'Alerts',
      UPDATES: 'Updates',
      LOGS: 'Logs',
      VIEW_ALL: 'View all',
      UPGRADE: 'Upgrade',
      GET_PRO_ACCESS: 'Get pro access',
      ALL_ROLES: 'All Roles',
      ALL_USERS: 'All Users',
      ALL_GROUPS: 'All Groups',
      ALL_STATUSES: 'All Statuses',
      NEW_NOTIFICATION: 'New Notification',
      MARK_AS_READ: 'Mark As Read',
      SUBJECT: 'Subject',
      MESSAGE: 'Message',
      TYPE: 'Type',
      ROLE: 'Role',
      USER: 'User',
      CREATION_TIME: 'Creation Time',
      STATUS: 'Status',
      ACTION: 'Action',
      GROUP: 'Group',
      NEW_NOTIFICATIONS: {
        ROLE_ID: 'Role Id',
        USER_NAME: 'User Name',
        TITLE: 'Title',
        ALL: 'All',
      },
    },
    GROUPS: {
      TITLE: 'Groups',
      NEW_GROUP: 'New Group',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      ROLES: 'Roles',
      CREATION_TIME: 'Creation Time',
      ACTION: 'Action',
    },
    IDENTITY: {
      TITLE: 'Identity',
      USERS: 'Users',
      NEW_USER: 'New User',
      NEW_ROLE: 'New Role',
      SEARCH: 'Search',
      USER_NAME: 'User name',
      FIRST_NAME: 'First Name',
      PASSWORD: 'Password',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email',
      ROLE: 'Role',
      ROLE_NAME: 'Role Name ',
      ACTIONS: 'Actions',
      SHOW: 'Showing',
      TO: 'to',
      OF: 'of',
      ENTRIES: 'entries',
      DESCRIPTION: 'Description',
    },
    DEPARTMENT: {
      TITLE: 'Departments',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      BUDGET: 'Budget',
      ACTIONS: 'Actions',
      ADD_NEW: 'Add Department',
      ADD_NEW_POSITION: 'Add Position',
      EDIT: 'Edit Department',
      POSITIONS: 'Positions',
      NEW_POSITION: 'New Position',
      EDIT_POSITION: 'Edit Position',
      POSITION_NAME: 'Position Name',
      POSITION_ID: 'Position Id',
      COEFFICIENT: 'Coefficient',
      CURRENCY: 'Currency',
    },
    EMPLOYEES: {
      TITLE: 'Employees',
      TAB_NAME: 'Employees',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      DATE_OF_BIRTH: 'Date of birth',
      SALARY_HISTORY: 'Salary History',
      ROLE: 'Role',
      ROLES: 'Roles',
      PHOTO: 'Photo',
      HARD_SKILLS: 'Hard skills',
      SKILLS: 'Skills',
      CERTIFICATIONS: 'Certifications',
      ADD_NEW: 'Add Employee',
      EDIT_EMPLOYEE: 'Edit employee',
      EMPLOYEE: 'Employee',
      EMPLOYEE_BENEFITS: 'Employee Benefits',
      EMPLOYEE_REHIRE: 'Rehire employee',
      EMPLOYEE_DISMISS: 'Dismiss employee',
      EMPLOYEE_BENEFIT_TYPE: 'Employee Benefit Type',
      DEPARTMENT: 'Department',
      POSITION: 'Position',
      WORK_STATUS: 'Work Status',
      INVENTORIES: 'Inventories',
      DISMISS: 'Are you sure you want to proceed with firing',
      REHIRE: 'Are you sure you want to proceed with rehiring',
      INITIATOR: 'Initiator',
      IS_FIRED: 'Is Fired',
      REPORT: 'Report',
      SPRINTS_INCLUDED: 'Sprints included',
      SUMMARY_FOR_PROJECT: 'Summary for project',
      ESTIMATED: 'Estimated',
      LOGGED: 'Logged',
      GENERATE_REPORT: 'Generate Report',
      ASSIGNED_HOURS: 'Assigned Hrs',
      TOTAL_LOGGED_TIME: 'Total Logged Time',
      ALL_PROJECTS: 'All Projects',
      TOTAL_ESTIMATED_TIME: 'Total Estimated Time',
      COMPLETION: 'Completion',
      PRODUCTIVITY: 'Productivity',
      EFFICIENCY_RATIO: 'Efficiency Ratio',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      PROJECTS_INCLUDED: 'Projects included',
      SPRINT_REPORT: 'Sprint Report',
      STORY_POINTS: 'Story  Points',
      BUG_FIXES: 'Bug Fixes',
      TICKETS_INCLUDED: 'Tickets included',
      OVERTIME: 'Overtime (Estimate - Log time)',
      STATUS: 'Status',
      AVERAGE_PRODUCTIVITY: 'Average Productivity',
      DOWNLOAD_REPORT: 'Download Report',
    },
    INTERVIEW: {
      TITLE: 'Interviews',
      INTERVIEWER: 'Interviewer',
      ADD_INTERVIEW: 'Add Interview',
    },
    RECRUITING: {
      TITLE: 'Recruiting',
      REFERRALS_TITLE: 'Referrals',
      ADD_CANDIDATE: 'Add candidate',
      APPROVE_CANDIDATE: 'Approve candidate',
      EDIT_CANDIDATE: 'Edit candidate',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      DATE_OF_BIRTH: 'Date of birth',
      HARD_SKILLS: 'Hard skills',
      DEPARTMENT: 'Department',
      SALARY: 'Salary',
      POSITION: 'Position',
      PHONE: 'Phone',
      CV: 'CV',
      LAST_COMPANY: 'Last Company',
      ADDRESS: 'Address',
      IS_PHONE_INTERVIEW: 'Phone Interview',
      DESCRIPTION: 'Description',
      CANDIDATE_STATUS: 'Candidate Status',
      EMPLOYMENT_DATE: 'Employment Date',
      GENDER: 'Gender',
    },
    REPORTS: {
      TITLE: 'Reports',
      DOCUMENT_TAB: 'Documents',
      CONTRACT_TAB: 'Contracts',
    },
    CERTIFICATES: {
      TAB_NAME: 'Certificates',
      NAME: 'Certificate Name',
      URL: 'Certificate URL',
      EMPLOYEE_NAME: 'Employee Name',
      EMPLOYEE_ID: 'Employee ID',
      EDIT_CERTIFICATE: 'Edit Certificate',
      NEW_CERTIFICATE: 'New Certificate',
      ADD_CERTIFICATE: 'Add certificate',
      REMOVE_CERTIFICATES: 'Remove Certificates',
    },
    USEFUL_LINKS: {
      DELETE_CONFIRMATION: 'Are you sure you want to delete this link?',
      SUCCESSFULLY_DELETED: 'Useful link was successfully deleted',
      LINK_SUCCESSFULLY_ADDED: 'New link was successfully added',
      CREATE_USEFUL_LINK: 'Create Useful Link',
      EDIT_USEFUL_LINK: 'Edit Useful Link',
      CREATE_LINK: 'Create Link',
      DELETE_LINK: 'Delete Link',
      USEFUL_LINK: 'Useful Link',
      COLOR: 'Background color',
      ADD_NEW: 'Add New Link',
      EDIT_LINK: 'Edit Link',
      ASSIGN_TO: 'Assign to',
      TITLE: 'Useful Links',
      LOGO: 'Logo',
      NAME: 'Name',
      LINK: 'URL',
    },
    WAGES: {
      TITLE: 'Wages',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMPLOYMENT_DURATION: 'Employment duration',
      WAGE: 'Wage',
    },
    EMPLOYEE_PROFILE: {
      SKILLS: 'Skills',
      CERTIFICATES: 'Certificates',
      WORK_INFO: 'Work Information',
      PROFILE_INFO: 'Profile Information',
      CREATE_REQUEST: 'Create request',
      INVENTORY_REQUEST: 'Inventory Request',
      BACK: 'Go Back',
      FULL_NAME: 'Full Name',
      BIRTH_DATE: 'Date of Birth',
      PHONE: 'Phone Number',
      EMAIL: 'Mail Address',
      BASE_SALARY: 'Base Salary',
      EMPLOYED_AT: 'Start Job',
      CURRENT_SALARY: 'Current Salary',
      EMPTY_STATE: 'Not set',
      NO_DEPARTMENT: 'No Department',
      NO_POSITION: 'No Position',
      NOT_BORN: "Isn't born yet",
      NO_PHONE: 'Phone number not set',
      NO_EMAIL: 'Email not set',
      OVERVIEW: 'Overview',
      INVENTORY: 'Inventory',
      ORDERS: 'Orders',
      ASSIGNED_INVENTORY: 'Assigned Inventory',
      NO_CONTRACT_FOUND: 'No contract found',
      CONTRACT_SALARY: 'Contract & Salary',
      INCOME: 'Income',
      NO_INVENTORY_FOUND: 'No items assigned',
      LOCATION: 'Location',
      WORK_TYPE: 'Work Type',
      LDAP_CONTROL: 'LDAP Control',
      REPORT: 'Report',
      LDAP_NOT_SET: 'LDAP is not set',
      USEFUL_LINKS: 'Useful Links',
      CONTRACT: 'Contract',
      MY_ORDERS: 'My Orders',
      PROJECT: 'Project',
      SPRINT: 'Sprint',
      BOARDS: 'Boards',
      EMPLOYEE: 'Employee',
    },
    REQUESTS: {
      TITLE: 'Requests',
    },
    VIRTUAL_PC: {
      TITLE: 'Virtual PC',
      EMAIL: 'Email',
      NAME: 'Name',
      STATUS: 'Status',
      PORT: 'Port',
      LDAP: 'LDAP',
      PROXMOX: 'Proxmox',
      IN_SYSTEM: 'In System',
      LDAP_STATUS: 'LDAP Status',
      VM_STATUS: 'VM Status',
      START: 'Start',
      STOP: 'Stop',
      RESTART: 'Restart',
      RESET_PASSWORD: 'Reset Password',
    },
    INVENTORY: {
      TITLE: 'Inventory',
      NAME: 'Name',
      CATEGORY: 'Category',
      CATEGORIES: 'Categories',
      ASSIGNEDTO: 'Assigned to',
      DESCRIPTION: 'Description',
      SERIALNUMBER: 'Serial number',
      COMPLETED_ON: 'Completed on',
      REJECTED_ON: 'Rejected on',
      PRICE: 'Price',
      STATUS: 'Status',
      TYPE: 'Type',
      STATE: 'State',
      CREATION_TIME: 'Creation time',
      REQUESTED_DATE: 'Requested date',
      RESPONSE_DATE: 'Response date',
      SELECT_ITEM: 'Select item',
      REQUESTED_ITEM: 'Requested item',
      REASON: 'Reason',
      ITEM_NOT_IN_LIST: 'Item not in list?',
    },
    INVENTORY_REQUESTS: {
      EMPLOYEES_REQUESTS: 'Employees Requests',
      ACTIVE_REQUESTS: 'Active Requests',
      VIEW_REQUESTS: 'View active requests',
      REJECT_REQUEST: 'Reject Request',
      APPROVE_REQUEST: 'Approve Request',
      REJECT_COMMENT: 'Reject Comment',
      LEAVE_COMMENT: 'Leave Comment',
      COMMENT: 'Comment',
      CONFIRM_REJECT: 'Confirm Reject',
      CONFIRM_APPROVE: 'Confirm Approve',
      CANCEL: 'Cancel',
      REQUEST_REJECTED: 'Request was successfully rejected',
      REQUEST_APPROVED: 'Request was successfully approved',
      NO_ACTIVE_REQUESTS: 'There are no active requests',
      REQUEST_SUCCESSFULLY_CREATED: 'Your request was successfully submited',
      REQUEST_SUCCESSFULLY_DELETED: 'Request was successfully deleted',
      SERIAL_COPIED: 'Serial number copied to clipboard',
      REQUEST_DETAILS: 'Request Details',
    },
    INVENTORY_CATEGORY: {
      TITLE: 'Inventory Category',
      NEW: 'New Inventory Category',
      EDIT: 'Edit Inventory Category',
      NAME: 'Inventory Category Name',
      ID: 'Inventory Category ID',
    },
    INVENTORY_MODAL: {
      TITLE: 'Add to inventory',
      ADD_NEW_ITEM: 'Add new item',
      EDIT_INVENTORY: 'Edit inventory',
      FILTER_INVENTORY: 'Filter inventory',
      CLEAR_FILER: 'Clear filter',
      APPLY_FILTER: 'Apply filter',
      REQUEST_ITEM: 'Request item from inventory',
      CREATE_REQUEST: 'Create request',
      DUPLICATE_ITEM: 'Duplicate item',
      DUPLICATE: 'Duplicate',
    },
    INTERVIEW_MODAL: {
      TITLE: 'Create Interview',
      ADD_INTERVIEW: 'Add Interview',
      EDIT_INTERVIEW: 'Edit Interview',
      CONFIRM_CHANGES: 'Confirm Changes',
      DATE_TIME: 'Date & Time',
      INTERVIEWEE: 'Interviewee',
      COMMENT: 'Comment',
      WRITE_COMMENT: 'Write a comment',
      POST_COMMENT: 'Post Comment',
      INTERVIEWERS: 'Interviewers',
      NO_COMMENTS: 'No comments yet.',
      STATUS: 'Status',
      CHANGE_STATUS: 'Change Status',
      CHANGE_INTERVIEW_STATUS: 'Change interview status',
      NO_COMMENT_PERMISSION: 'You do not have permission to comment',
      DELETE_COMMENT: 'Delete Comment',
      EDIT_COMMENT: 'Edit Comment',
      DELETE_COMMENT_CONFIRMATION: 'Are you sure you want to delete this comment?',
    },
    CALENDARS: {
      TITLE: 'Calendars',
      EVENT_TYPE: 'Event type',
      NEW_EVENT_TYPE: 'New Event Type',
      EDIT_EVENT_TYPE: 'Edit Event Type',
      EVENT_TYPE_ID: 'Event type ID',
      CREATION_DATE: 'Creation date',
      START_DATE: 'Start Date',
      DATE: 'Date',
      END_DATE: 'End Date',
      COEFFICIENT: 'Coefficient',
      NOTES: 'Notes',
      SELECT_DATE: 'Select Date',
      COEFFICIENT_CHANGE_NOTE: 'Coefficient change note',
      IS_COEFFICIENT_REQUIRED: 'Is coefficient required',
      SELECTED_RANGE: 'Selected Range',
      SELECTED_DATE: 'Selected Date',
    },
    COMMON: {
      SEARCH: 'Search',
      PAGINATION: 'Showing {{from}} to {{to}} of {{all}} entries',
      NO_DATA_AVAILABLE_IN_TABLE: 'No data available in table',
      NO_ACTIVE_SPRINTS: 'There are no active sprints',
      SELECT_PROJECT_FIRST: 'Select Project to see active sprints',
      START_SPRINTS: 'Start sprints in the',
      COPY_TO_CLIPBOARD: 'Copied to clipboard: {{value}}',
      GO_TO: 'Go to page',
      ITEMS_PER_PAGE: 'Items per page',
      ADD_SUCCESS: 'Successfully added',
      EDIT_SUCCESS: 'Successfully edited',
      UPDATE_SUCCESS: 'Successfully updated',
      DELETE_SUCCESS: 'Successfully deleted',
      CANDIDATE_HIRED: 'Candidate is now hired',
      CANDIDATE_STATUS_UPDATED: 'Successfully updated candidate status',
      NO_CATEGORY: 'No Category',
      NO_URL: 'No URL',
      TOTAL_ISSUES: '{{total}} issues',
      TOTAL_ACTIVITIES: '{{total}} activities',
      TOTAL_SUB_TASK: 'sub-tasks',
      CONTRACT_NOT_SIGNED: 'No Signed Contract',
      LABEL: {
        DATE: 'Date',
        ALL: 'All',
        EMPLOYEE: 'Employee',
        NEED_APPROVEMENT: 'Need approval?',
        PROJECTS: 'Projects',
        REFERENCE: 'Reference',
        RATE: 'Rate Employee',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        PENDING: 'Pending',
        BLOCKED: 'Blocked',
        CLOSED: 'Closed',
        CONTRACT: 'Contract',
        CV: 'CV',
        START_JOB: 'Start Job',
        EVENT_TYPE: 'Event Type',
        EVENT_TYPE_COLOR: 'Event Type Color',
        SELECT_EVENT_TYPE: 'Select Event Type',
        SELECT_EMPLOYEE: 'Select Employee',
        SELECT_DEPARTMENT: 'Select Department',
        SELECT_INVENTORY_CATEGORY: 'Select Inventory Category',
        ASSIGN_INVENTORY: 'Assign Existing Inventory',
        SELECT_POSITION: 'Select Position',
        SPRINT_NAME: 'Sprint Name',
        GOAL: 'Goal',
        DURATION: 'Duration',
        ACTIVITIES: 'Activities',
        PROJECT_NAME: 'Project Name',
        BOARD_NAME: 'Board Name',
        PROJECT_STATUS: 'Project Status',
        SPRINT_STATUS: 'Sprint Status',
        TEAM_MEMBER: 'Team Member',
        TASK_NAME: 'Task Name',
        TASK_DESCRIPTION: 'Task Description',
        TASK_TYPE: 'Task Type',
        SELECT_TASK_TYPE: 'Select Task Type',
        ASSIGNEE: 'Assignee',
        STAGE: 'Stage',
        FILTER_OPTIONS: 'Filter Options',
        TIME_RANGE: 'Is time range?',
        WORK_STATUS_NAME: 'Work Status Name',
        CURRENCY: 'Currency',
        PRICE: 'Price',
        EDIT_PROJECT: 'Edit Project',
        DELETE_PROJECT: 'Delete Project',
        ADD_MEMBERS: 'Add Members',
        SUM: 'Sum',
      },
      PLACEHOLDER: {
        CHOOSE_DEPT: 'Choose a department first',
        SELECT_EMPLOYEE: 'Select Employee',
        SELECT_PROJECT: 'Select Project',
        SELECT_EVENT_TYPE: 'Select Event Type',
        SELECT_COMPANY: 'Select Company',
        SELECT_DEPARTMENT: 'Select Department',
        SELECT_TEAM_LEAD: 'Select Team Lead',
      },
    },
    AUTH: {
      // ? ACTUAL
      TITLES: {
        LOGIN: 'Login to your account',
        REGISTER: 'Create an account',
        FORGOT: 'Forgotten Password?',
        RESET_PASSWORD: 'Reset Password',
      },
      // ? ACTUAL

      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        PLEASE_WAIT: 'Please wait',
        CONTINUE: 'Continue',
      },
      LOGIN: {
        TITLE: 'Login with',
        BUTTON: 'Sign In',
        NEW_HERE: 'New Here',
        CONTINUE_WITH_GOOGLE: 'Continue with Google',
      },
      FORGOT: {
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        ALREADY_HAVE_ACCOUNT: 'Already have account',
        SIGN_IN: 'Sign In',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfully registered.',
        AGREE: 'I agree with',
        TERMS_AND_CONDITIONS: 'terms and conditions',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: 'Field is not valid',
        REQUIRED: 'Field is required',
        MIN_LENGTH: 'Field minimum length is',
        MAX_LENGTH: 'Field maximum length is',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length: {{reqLength}}',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        MUST_MATCH: "Passwords don't match!",
        EMAIL_FORMAT_NOT_GOOD: 'Email format not good',
        POSITIVE_NUMBER: 'Field requires a positive number',
        PATTERN: 'Please enter a valid format',
      },
    },
    DASHBOARD: {
      WELCOME_MESSAGE: 'Welcome home',
      LANGUAGE: 'Language',
      SIGN_OUT: 'Sign out',
      DATE_RANGE_PICKER: 'Date range picker',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      LAST_7_DAYS: 'Last 7 days',
      LAST_30_DAYS: 'Last 30 days',
      THIS_MONTH: 'This month',
      LAST_MONTH: 'Last month',
      ALL_TIME: 'All time',
    },
    COMPANIES: {
      TITLE: 'Companies',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      CODE: 'Code',
      IS_DEFAULT: 'Is default',
      ADD_COMPANY: 'Add company',
      EDIT_COMPANY: 'Edit company',
      ADDRESS: 'Address',
      MONTHLY_WORKING_HOURS: 'Monthly Working Hours',
    },
    BUTTON: {
      SAVE: 'Save',
      CANCEL: 'Cancel',
      NEW_INVENTORY: 'New Inventory',
      NEW_INVENTORY_CATEGORY: 'New Inventory Category',
      PREVIOUS: 'Previous',
      TODAY: 'Today',
      ADD_INVENTORY_CATEGORY: 'Add Inventory Category',
      NEXT: 'Next',
      ADD: 'Add',
      ADD_INVENTORY: 'Add Inventory',
      CREATION_DATE: 'Created',
      START_DATE: 'Started',
      YES: 'Yes',
      NO: 'No',
      DOWNLOAD: 'Download',
      ADD_CONTRACT: 'Add Contract',
      ADD_ORDER: 'Add Order',
      CREATE_SPRINT: 'Create Sprint',
      CREATE_TASK: 'Create Task',
      EDIT_TASK: 'Edit Task',
      ADD_DOC: 'Add Document',
      CREATE_TEAM: 'Create Team',
      CREATE_PROJECT: 'Create Project',
      UPDATE: 'Update {{item}}',
      DELETE: 'Delete {{item}}',
      TEAM_UP: 'Team Up',
      FILTER: 'Filter',
      ADD_SKILL: 'Add Skill',
      APPLY: 'Apply',
      START: 'Start',
      STOP: 'Stop',
      RESET: 'Reset',
      ADD_CERTIFICATE: 'Add Certificate',
      ADD_WORK_STATUS: 'Add Work Status',
      ADD_DEPT: 'Add Department',
      ADD_POSITION: 'Add Position',
      ADD_ORDER_TYPE: 'Add Order Type',
      ADD_KARMA: 'Add Karma',
      ADD_EVENT_TYPE: 'Add Event Type',
      GENERATE: 'Generate',
      REJECT: 'Reject',
      CLOSE: 'Close',
    },
    KPI: {
      TITLE: 'Kpi',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      EMPLOYEES: 'Employees',
      NOTES: 'Notes',
      SALARY_INCREASE_RATE: 'Salary Increase Rate',
      PRODUCTIVITY_INCREASE_COEF: 'Productivity Increase Coefficient',
      CHECKLIST: 'Check List',
      REJECT_MESSAGE: 'Reject Message',
    },
    ACCOUNT: {
      OVERVIEW: 'Overview',
      SETTINGS: 'Settings',
      PROFILE_DETAILS: 'Profile details',
      FULL_NAME: 'Full name',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      CONTACT_PHONE: 'Contact phone',
      COMMUNICATION: 'Communication',
      ALLOW_CHANGES: 'Allow changes',
      YES: 'Yes',
      AVATAR: 'Avatar',
      CHANGE_AVATAR: 'Change Avatar',
      CHOOSE_FILE: 'Choose File',
      SAVE_CHANGES: 'Save Changes',
      EDIT_PROFILE: 'Edit Profile',
      PROFILE_DETAILS_UPDATED: 'Profile details are updated!',
      LOGOUT: 'Logout',
    },
    CONTRACTS: {
      CONTRACT_NAME: 'Contract Name',
      CONTRACT_DESCRIPTION: 'Contract Description',
      DESCRIPTION: 'Description',
    },
    DOCUMENTS: {
      DOCUMENT_NAME: 'Document Name',
      DOCUMENT_DESCRIPTION: 'Document Description',
      DESCRIPTION: 'Description',
    },
    ORDERS: {
      TITLE: 'Orders',
      NAME: 'Name',
      NOTE: 'Note',
      TYPE: 'Type',
      ORDER_TYPE: 'Order Type',
      EMPLOYEE: 'Employee',
      DEPARTMENT: 'Department',
      STATUS: 'Status',
      COMPLETED: 'Completed',
      IN_PROGRESS: 'In Progress',
      FAILED: 'Failed',
      EXPIRED: 'Expired',
      CANCELLED: 'Cancelled',
      ALL: 'All',
    },
    PROFILE: {
      INFO: {
        TITLE: 'Profile',
        USER_NAME: 'User Name',
        ROLE: 'Role',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        DATE_OF_BIRTH: 'Date of Birth',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'Zip',
        ADDRESS: 'Address',
        EMAIL: 'Email',
        PHONE: 'Phone',
        NOTIFICATIONS: 'Notifications',
        TIMEZONE: 'Timezone',
        PASSWORD: 'Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm new password',
        LOGOUT: 'Logout',
      },
    },
    TASK_TYPES: {
      TITLE: 'Task Types',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      DEPARTMENT: 'Department',
      EDIT_TASK_TYPE: 'Edit Task Type',
      DELETE_TASK_TYPE: 'Delete Task Type',
      ADD_TASK_TYPE: 'Add Task Type',
    },
    TICKETS: {
      TITLE: 'Tickets',
    },
    KARMA: {
      TITLE: 'Karma',
    },
    SPRINTS: {
      TITLE: 'Sprints',
    },
    REFERRALS_ACTIVATE: {
      GO_TO_PAGE: 'Go to page',
    },
    SIGN_IN_METHOD: {
      TITLE: 'Sign-In Method',
      EMAIL_ADDRESS: 'Email Address',
      CHANGE_EMAIL: 'Change Email',
      PASSWORD: 'Password',
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_CURRENT_PASSWORD: 'Confirm New Password',
      RESET_PASSWORD: 'Reset password',
      ENTER_NEW_EMAIL_ADDRESS: 'Enter new email address',
      UPDATE_EMAIL: 'Update Email',
      UPDATE_PASSWORD: 'Update password',
      CANCEL: 'Cancel',
      PASSWORD_WAS_UPDATED: 'Password has been updated successfully',
      INCORRECT_PASSWORD: 'Incorrect password',
      PASSWORD_RULE: 'Password must be at least 6 character and contain symbols',
      VALIDATION: {
        CURRENT_PASS_REQUIRED: 'Current password is required!',
        CURRENT_PASS_MIN: 'Current password should have at least 6 symbols',
        CURRENT_PASS_MAX: 'Current password should have maximum 25 symbols',
        NEW_PASS_REQUIRED: 'New password is required!',
        NEW_PASS_MIN: 'New password should have at least 6 symbols',
        NEW_PASS_MAX: 'New password should have maximum 25 symbols',
        CONFIRM_PASS_REQUIRED: 'Current password is required!',
        PASS_DO_NOT_MATCH: "Passwords don't match!",
      },
    },
    SPRINT: {
      TITLE: 'Board Sprint',
    },
    FOOTER: {
      RIGHTS: 'All rights reserved',
      POWERED_BY: 'Powered by',
    },
  },
};
